import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import '../../scss/main.scss';
import './school-admin.scss';
import SchoolAdmin from './components/SchoolAdmin.jsx';

ReactDOM.render(
  <SchoolAdmin />,
  document.getElementById('root'),
);
